import { useEffect, useRef } from "react";

// Хук был реализован по статье
// https://overreacted.io/making-setinterval-declarative-with-react-hooks/
export const useIntervalAsync = (callback, delay) => {
  const savedCallback = useRef();

  // Сохраняем последнюю версию функции callback
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Устанавливаем интервал
  useEffect(() => {
    async function tick() {
      if (savedCallback.current) {
        await savedCallback.current(); // Ожидание выполнения асинхронной функции
      }
    }

    if (delay !== null) {
      const id = setInterval(tick, delay); // Интервал вызывает tick
      return () => clearInterval(id); // Очистка интервала при изменении delay или размонтировании
    }
  }, [delay]);
};
